import React, { useContext } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Input, Select } from 'semantic-ui-react';
import {
  errorInput,
  eventSlugnameTrim,
  seminary,
  clickableStyles,
  kindgrouplist,
  searchSelectProps,
} from 'src/components/helpers';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import useRememberCredentials from 'src/components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from 'src/components/helpers/RememberCredentialsCheckbox';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';
import { ListsContext } from 'src/services/contextProviders/lists/listsContext';
import { RegistrationForm } from 'src/assets/styles/components/Registration';

const GroupsLogs = (props) => {
  const { inputs, setInputs, leaders, getInfo, parsedQueryString, set_loading, loading } = props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const [filterKindOfGroup, set_filterKindOfGroup] = React.useState(false);
  const { groupCategories } = useContext(ListsContext);
  const getCaptchaToken = useRecaptchaToken('group_login');
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];
    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs['identification'] && inputs['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: inputs['identification'].length >= 5,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  React.useEffect(() => {
    if (!parsedQueryString.activityName && inputs.kindgroup)
      props.history.push(`?kindgroup=${inputs.kindgroup}`);
  }, [inputs.kindgroup]);

  React.useEffect(() => {
    if (
      parsedQueryString.identification &&
      parsedQueryString.phone &&
      inputs.identification &&
      inputs.phone
    )
      enterReservation({ preventDefault: () => {} });
    if (parsedQueryString.filterKindOfGroup) {
      set_filterKindOfGroup(true);
      Swal.fire('Selecciona la categoria que deseas filtar y luego presiona entrar');
    }
  }, [inputs.identification]);

  const enterReservation = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    set_loading(true);

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });

    getInfo({
      ...(captchaRequired ? { captcha } : {}),
      kind: inputs.kind || '',
      activityName: inputs.activityName || '',
    });
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  const selectHandle = (a, { value, name }) => {
    if (name === 'kindgroup') {
      setInputs({
        ...inputs,
        kindgroup: value,
        kind: value,
        activityName: '',
      });
      return;
    }
    handleInputs({ target: { value, name } });
  };

  const formSelect = ({ name, label, value, options = [], style = {}, handler = selectHandle }) => (
    <Select
      style={style}
      placeholder={label}
      className={errorInputs[name] ? 'error' : ''}
      id={name}
      {...searchSelectProps({
        name,
        value,
        handler,
        options: options.map((opt) => {
          return { key: opt, value: opt, text: eventSlugnameTrim(opt) };
        }),
      })}
    />
  );

  const categoriesgrouplist = inputs.kindgroup === 'Grupo_Seminario' ? seminary : groupCategories;

  return (
    <>
      <h1>¡Bienvenido{Boolean(leaders) && ' Líder'}!</h1>
      <RegistrationForm onSubmit={(e) => enterReservation(e)}>
        <label style={{ display: 'block', padding: '20px', fontSize: '35px' }}>
          Escribe tus datos
        </label>
        {Object.values(errorInputs).includes(true) && (
          <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
        )}
        <Input
          style={{ width: '45%' }}
          onChange={handleInputs}
          name={'identification'}
          value={inputs.identification}
          type="number"
          placeholder="Identificación"
          id="identification"
          className={`Registration__input Registration__input-${'identification'} ${
            errorInputs['identification'] ? 'error' : ''
          }`}
        />
        <Input
          placeholder="Celular"
          id="phone"
          name={'phone'}
          type="number"
          className={`Registration__input Registration__input-${'phone'} ${
            errorInputs['phone'] ? 'error' : ''
          }`}
          value={inputs.phone}
          onChange={handleInputs}
          style={{ width: '45%', margin: '5px' }}
        />
        <RememberCredentialsCheckbox
          checked={rememberCredentials}
          onChange={setRememberCredentials}
        />
        {!filterKindOfGroup ? (
          <p
            style={{ ...clickableStyles, margin: '0 0 20px 0' }}
            onClick={() => set_filterKindOfGroup(true)}
          >
            Seleccionar tipo de grupo
          </p>
        ) : (
          <div>
            <div
              className="Registration__input"
              style={{
                padding: '0 25px 0 10px',
                width: '45%',
                margin: '5px',
                display: 'inline-block',
              }}
            >
              {formSelect({
                label: 'Tipo de Registro',
                style: { width: '100%', minWidth: '100%' },
                name: 'kindgroup',
                value: inputs.kindgroup,
                errorInputs,
                options: kindgrouplist,
              })}
            </div>
            {formSelect({
              label: 'Categoría',
              name: 'activityName',
              style: { width: '45%', margin: '5px' },
              value: inputs.activityName || '',
              errorInputs,
              options: categoriesgrouplist,
            })}
          </div>
        )}

        <Button primary disabled={loading} type="submit">
          Entrar
        </Button>
      </RegistrationForm>
    </>
  );
};

export default withRouter(GroupsLogs);
